import React from "react";
import ReactHtmlParser from "react-html-parser";
import { handleClickScroll } from "utils";

const ServiceCard = ({ customCss, title, description }) => {
  return (
    <div
      className={`w-full shadow-xl flex flex-col p-4 my-4 rounded-lg hover:scale-105 duration-300 ${customCss}`}
    >
      <h2 className="text-xl font-bold text-center py-8">
        {ReactHtmlParser(title)}
      </h2>
      <div className="text-center font-small">
        <div className="py-2 border-t mx-8 mt-2">
          {ReactHtmlParser(description)}
        </div>
      </div>
      <button
        className="bg-[#00df9a] w-[200px] hover:opacity-75 rounded-md font-medium my-6 mx-auto px-6 py-3"
        onClick={() => handleClickScroll("contact")}
      >
        Contact Us
      </button>
    </div>
  );
};

export default ServiceCard;
